import { ReactComponent as ArrowDown } from '../../assets/icons/ArrowDown.svg';
import Select from '../inputs/Selects/Select/Select';

import classes from './Pagination.module.scss';

const window = 5;

const limits = [
  { value: 25, label: 25 },
  { value: 50, label: 50 },
  { value: 75, label: 75 },
  { value: 100, label: 100 }
];

const Pagination = ({ className, pages, current, showNext, onPrevious, onNext, onPage, onLimit, limit }) => {
  const half = Math.round(window / 2);

  let start = current - half + 1;
  if (start < 0) {
    start = 0;
  }

  let end = current + half;
  if (end > pages - 1) {
    end = pages;
  }

  const items = [];
  for (let index = start; index < end; index++) {
    items.push(index);
  }

  let containerClassses = [classes.container];
  if (className) {
    containerClassses.push(className);
  }

  const showPrevious = current > 0;

  return (
    <div className={containerClassses.join(' ')}>
      {onLimit && (
        <div className={classes.limit}>
          <span className='semibold-14'>Items por pagina</span>
          <Select name='selectPagination' className={classes.select} onChange={onLimit} options={limits} value={limit} />
        </div>
      )}
      {showPrevious && (
        <div className={`${classes.prev} pointer`} onClick={onPrevious}>
          <ArrowDown className={classes['previous-icon']} /> <span className='medium-14'>Anterior</span>
        </div>
      )}
      <div className={classes.pages}>
        {items.length > 1 &&
          items.map(index => {
            const itemWeigthClass = index === current ? classes.selected : classes['not-selected'];
            const itemClasses = [classes.item, 'semibold-14', itemWeigthClass];
            return (
              <span key={index} className={itemClasses.join(' ')} onClick={() => onPage(index)}>
                {index + 1}
              </span>
            );
          })}
      </div>
      {showNext && (
        <div className={`${classes.next} pointer`} onClick={onNext}>
          <span className='medium-14'>Siguiente</span>
          <ArrowDown className={classes['next-icon']} />
        </div>
      )}
    </div>
  );
};

export default Pagination;
